/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { useAriaLive } from '@ally/use-aria-live';
import { buildRecursiveString } from '../../../tools/utils';
import { a11y } from '../../strings';
export const useTableSort = ({ column: { Header, id, ariaLabel, isSorted, isSortedDesc }, tableCaption, getAriaLiveSort = a11y.getAriaLiveTableHeader, }) => {
    const [isMounted, setMounted] = useState(false);
    const { announcePolite } = useAriaLive();
    const sortState = useMemo(() => {
        if (!isSorted)
            return 'none';
        if (isSortedDesc)
            return 'descending';
        return 'ascending';
    }, [isSorted, isSortedDesc]);
    const safeColumnName = useMemo(() => {
        if (ariaLabel)
            return ariaLabel;
        if (typeof Header === 'string')
            return Header;
        if (React.isValidElement(Header)) {
            const headerContent = buildRecursiveString(Header);
            if (headerContent.length > 0)
                return headerContent;
        }
        return id;
    }, [id, ariaLabel, Header]);
    const generateAriaLiveAnnouncement = useCallback(() => {
        if (!isSorted)
            return null;
        return getAriaLiveSort(tableCaption, safeColumnName, !!isSortedDesc);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSorted, tableCaption, safeColumnName, isSortedDesc]);
    useEffect(() => {
        if (!isMounted) {
            setMounted(true);
            return;
        }
        if (isSorted) {
            const announcement = generateAriaLiveAnnouncement();
            if (announcement !== null)
                announcePolite(announcement);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSorted, isSortedDesc]);
    return { sortState, safeColumnName };
};
//# sourceMappingURL=useTableSort.js.map